<div class="estimate-install-type-container">
    <div class="row pb-3">
        <label class="estimate-install-type-label">{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_TITLE' |
            translate}}</label>
    </div>
    <div class="estimate-install-type-content" [formGroup]="installTypeForm">
        <div class="row install-type-container">
            <div class="col-sm-3">
                <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_LABEL' | translate}}</label>
            </div>
            <div class="col-sm-4">
                <mat-form-field class="full-width col-sm-12" appearance="outline">
                    <mat-select formControlName="installType">
                        <mat-option *ngFor="let type of installTypes; trackBy: trackById" [value]="type.id">
                            {{type.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <a href="{{decisionToolLink}}" target="_blank" class="custom-anchor">
                    {{'DECISION_TOOL_LINK_TEXT' | translate}}
                </a>
            </div>
        </div>
        @if (isSecurityEstimate) {
        <div class="row install-type-container apply-in-guide-view-container padding-guide-view">
            <div class="col-sm-3 apply-in-guide-view-label-column">
                <div class="apply-in-guide-view-label-content">
                    <mat-checkbox color="primary" formControlName="applyInGuideView">
                        <span>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_APPLY_IN_GUIDE_VIEW' | translate}}</span>
                    </mat-checkbox>
                    <mat-icon [matTooltip]="'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_APPLY_IN_GUIDE_VIEW_TOOLTIP' | translate" matTooltipPosition="below">info</mat-icon>
                </div>
            </div>
        </div>
        }
        <fieldset>
            <legend>{{"TAX" | translate}}</legend>
            <div class="row estimate-tax-type-container">
                <div class="col-sm-3">
                    <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_TAX_TYPE' | translate}}</label>
                </div>
                <div class="col-sm-4 tax-type-container">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <mat-select formControlName="taxType">
                            <mat-option *ngFor="let tax of taxTypes; trackBy: trackByIndex" [value]="tax.id">
                                {{tax.description }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row material-rate-container">
                <div class="col-sm-3"></div>
                @if (showMaterialRate){
                <div class="col-sm-3 row">
                    <div class="col-sm-6 material-rate-label">
                        <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_MATERIAL_RATE' | translate}}</label></div>
                    <div class="col-sm-6">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput [appNumericMask]= "materialAndLaborRateConfig"  formControlName="materialRate">
                        </mat-form-field>
                    </div>
                </div>
                }

                @if(showLaborRate){
                <div class="col-sm-3 row">
                    <div class="col-sm-6"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_LABOR_RATE' |
                            translate}}</label></div>
                    <div class="col-sm-6">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput  [appNumericMask]= "materialAndLaborRateConfig" formControlName="laborRate">
                        </mat-form-field>
                    </div>
                </div>
                }

            </div>
        </fieldset>
        <fieldset *ngIf="!isSecurityEstimate">
            <legend>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_PROVIDED_BY_OTHERS' | translate}}</legend>
            <div class="row row-height">
                <div class="col-sm-4">
                    <mat-checkbox color="primary" formControlName="providedByOthersMech">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_MECH' | translate}}
                    </mat-checkbox>
                </div>
                <div class="col-sm-3">
                    <mat-checkbox color="primary" formControlName="providedByOthersElec">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_ELEC' | translate}}
                    </mat-checkbox>
                </div>
            </div>
        </fieldset>
        <fieldset *ngIf="isFireEstimate" [formGroup]="fireTerminationForm">
            <legend>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION' | translate}}</legend>
            <div class="row row-height">
                <div class="col-sm-4">
                    <mat-checkbox color="primary" formControlName="firePanelTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_FIRE_PANEL' | translate}}
                    </mat-checkbox>
                </div>
                <div class="col-sm-6">
                    <mat-checkbox color="primary" formControlName="devicesTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_DEVICES' | translate}}
                    </mat-checkbox>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-4">
                    <mat-checkbox color="primary" formControlName="padPanelTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_PAD_PANEL' | translate}}
                    </mat-checkbox>
                </div>
                <div class="col-sm-6">
                    <mat-checkbox color="primary" formControlName="vesdaDetectorTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_VESDA_DETECTOR' | translate}}
                    </mat-checkbox>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-4">
                    <mat-checkbox color="primary" formControlName="remoteAnnunciatorTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_REMOTE_ANNUNCIATOR' | translate}}
                    </mat-checkbox>
                </div>
                <div class="col-sm-6">
                    <mat-checkbox color="primary" formControlName="audioVisualDevicesTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_AUDIO_VISUAL_DEVICES' |
                        translate}}
                    </mat-checkbox>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-4">
                    <mat-checkbox color="primary" formControlName="endOfLineTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_END_OF_LINE' | translate}}
                    </mat-checkbox>
                </div>
                <div class="col-sm-6">
                    <mat-checkbox color="primary" formControlName="flameBeamDetectorTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_FLAME_BEAM_DETECTOR' |
                        translate}}
                    </mat-checkbox>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-5">
                    <mat-checkbox color="primary" formControlName="combinedSpeakerStrobeTermination">
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_FIRE_TERMINATION_COMBINED_SPEAKER_STROBE' |
                        translate}}
                    </mat-checkbox>
                </div>
                <div class="col-sm-3"></div>
            </div>
        </fieldset>
        <fieldset *ngIf="!opportunityIntegrationOptionsVisibility()">
            <legend>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_OPPORTUNITY_INTEGRATIONS_OPTIONS' | translate}}
            </legend>
            <div class="row row-height opportunity-integration-options-container">
                <div class="col-sm-4"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_SELL_PRICE' |
                        translate}}</label></div>
                <div class="col-sm-8">
                    <mat-radio-group formControlName="sellPrice">
                        <mat-radio-button color="primary" class="mr-3" [value]="true">
                            {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_WITH_SALES_TAX'|translate}}
                        </mat-radio-button>
                        <mat-radio-button color="primary" class="mr-3" [value]="false">
                            {{'MENU_FILE_PROPERTIES_ESTIMATE_INSTALL_TYPE_WITHOUT_SALES_TAX'|translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </fieldset>
    </div>
</div>